module.exports = [
  { // Gender
    question: {
      label: 'What is your gender, from birth?',
      prompt: 'gender'
    }, 
    input: 'radio',
    options: [
      { label: 'Male', value: 'male' },
      { label: 'Female', value: 'female' },
    ]
  },
  { // Age
    question: {
      label: 'How old are you?',
      prompt: 'age'
    }, 
    input: 'radio',
    options: [
      { label: '35 or younger', value: '35 or younger' },
      { label: '36-50', value: '36-50' },
      { label: '51-65', value: '51-65' },
      { label: '66-80', value: '66-80' },
      { label: '81 or older', value: '81 or older' }
    ]
  },
  { // Pain
    question: {
      label: 'What level of pain are you feeling right now?',
      prompt: 'pain'
    },
    input: 'slider'
  },
  { // Cause
    question: {
      label: 'Is this condition a result of:',
      prompt: 'cause'
    }, 
    input: 'radio',
    options: [
      { label: 'Accident or Sports Injury', value: 'sports_injury' },
      { label: 'Progressive Arthritis/Tendonitis', value: 'arthritis_tendonitis' },
      { label: 'Not Sure', value: 'unknown' },
    ]
  },
  { // Past Treatments
    question: {
      label: `Mark any treatments you've had`,
      prompt: 'past_treatments'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Injection', value: 'injection' },
      { label: 'Physical Therapy', value: 'pt' },
      { label: 'Imaging (x-ray, MRI)', value: 'imaging' },
      { label: 'Surgery', value: 'surgery' },
      { label: 'None of the Above', value: 'none' },
    ]
  },
  { // Past Visits
    question: {
      label: `Have you had an evaluation by medical personnel?`,
      prompt: 'past_visits'
    }, 
    input: 'checkbox',
    options: [
      { label: 'Primary Care', value: 'primary' },
      { label: 'Orthopedic', value: 'orthropedic' },
      { label: 'Emergency Care', value: 'er' },
      { label: 'Chiropractor', value: 'chiropractor' },
      { label: 'None', value: 'none' },
    ]
  },
  { // Pain Description
    question: {
      label: 'Describe your pain',
      prompt: 'pain_description'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Chronic', value: 'chronic' },
      { label: 'Acute', value: 'acute' },
      { label: 'Intermittent', value: 'intermittent' }
    ]
  },
  { // Swelling
    question: {
      label: 'Describe your swelling',
      prompt: 'swelling'
    }, 
    input: 'radio',
    options: [
      { label: 'None', value: 'none' },
      { label: 'Moderate', value: 'moderate' },
      { label: 'Severe', value: 'severe' },
    ]
  },
  { // Instability on Weight-Bearing
    question: {
      label: 'Do you have issues with weight-bearing or instability in your knee?',
      prompt: 'weightbearing_instability'
    }, 
    input: 'radio',
    options: [
      { label: 'No Issues', value: 'none' },
      { label: 'Moderate', value: 'moderate' },
      { label: 'Severe', value: 'severe' },
    ]
  },
  { // Popping/Snapping
    question: {
      label: 'Have you felt a pop or snap within the affected joint?',
      prompt: 'popping_snapping_catching'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Knee ROM
    question: {
      label: `Is your knee's range of motion`,
      prompt: 'rom'
    }, 
    input: 'radio',
    options: [
      { label: 'Painful or Unable to Perform', value: 'painful_or_unable' },
      { label: 'Decreasing', value: 'decreasing' },
      { label: 'Limited', value: 'limited' },
      { label: 'Normal', value: 'normal' },
    ]
  },
  { // Grinding/Catching While Walking
    question: {
      label: 'Any sense of grinding or catching inside the joint while walking?',
      prompt: 'grinding'
    }, 
    input: 'radio',
    options: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' },
    ]
  },
  { // Pain Location
    question: {
      label: 'Where is your knee pain located?',
      prompt: 'pain_location'
    }, 
    input: 'radio',
    options: [
      { label: 'Inner medial side', value: 'inner_medial' },
      { label: 'Outer lateral side', value: 'outer_lateral' },
      { label: 'Around Knee Cap (Patella)', value: 'patella' },
      { label: 'The entire knee', value: 'entire_knee' },
    ]
  },
]